import { getAppVersion } from '@/tool';
const isGlobal = getAppVersion() === 'GLOBAL'

const app = {
  state: {
    accept:false,
    conutry:{src:'usa',money: isGlobal ? 'USD' : 'CNY'},
    alertinfo:{type:'error',content:'',showis:false},
    // 是否是国际版
    isGlobal,
    showLoading: false,
  },

  mutations: {
    SET_ACCEPT: (state, accept) => {
      state.accept = accept
    },
    SET_COUNTRY: (state, conutry) => {
      state.conutry = conutry
    },
    SET_ALERT: (state, alertinfo) => {
      state.alertinfo = alertinfo
    },
    SET_SHOWLOADING: (state, showLoading) => {
      state.showLoading = showLoading
    },
  },

  actions: {

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          dispatch('GenerateRoutes', data) // 动态修改权限后 重绘侧边菜单
          resolve()
        })
      })
    },
    setShowLoading({ commit }, s) {
      commit('SET_SHOWLOADING', s)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/app.js